import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";

import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";

const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);
const ChurchesPage = lazy(() => import("./icomos/pages/churches/ChurchesPage"));

const ChurchEdit = lazy(() =>
  import("./icomos/pages/churches/church-edit/ChurchEdit")
);

const ChurchView = lazy(() =>
  import("./icomos/pages/churches/church-view/ChurchView")
);

const UsersPage = lazy(() => import("./icomos/pages/users/UsersPage"));

const UserEdit = lazy(() => import("./icomos/pages/users/user-edit/UserEdit"));

const MapsPage = lazy(() => import("./icomos/pages/maps/MapsPage"));
const HomePage = lazy(() => import("./icomos/pages/home/HomePage"));
const ZaProektotPage = lazy(() => import("./icomos/pages/za-proektot/zaProektotPage"));

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  const user = useSelector((state) => state.auth.user, shallowEqual);
  const isAdminOrOperator = [2, 3].includes(user?.UserRole.roleId);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /home. */
          <Redirect exact from="/" to="/home" />
        }
        <Route path="/home" component={HomePage} />
        <Route path="/za-proektot" component={ZaProektotPage} />

        {/* icomos routes */}
        {/* churches - START*/}
        {isAdminOrOperator ? (
          <ContentRoute path="/churches/new" component={ChurchEdit} />
        ) : null}
        {isAdminOrOperator ? (
          <ContentRoute path="/churches/:id/edit" component={ChurchEdit} />
        ) : null}
        <ContentRoute path="/churches/:id/view" component={ChurchView} />
        <ContentRoute path="/map/churches/:id/view" component={ChurchView} />

        <ContentRoute path="/churches" component={ChurchesPage} />
        {/* churches - END*/}

        {/* users - START*/}
        {isAdminOrOperator ? (
          <ContentRoute path="/users/new" component={UserEdit} />
        ) : null}
        {isAdminOrOperator ? (
          <ContentRoute path="/users/:id/edit" component={UserEdit} />
        ) : null}
        {isAdminOrOperator ? (
          <Route path="/users" component={UsersPage} />
        ) : null}
        {/* users - END*/}

        <Route path="/maps" component={MapsPage} />

        <Route path="/user-profile" component={UserProfilepage} />

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
